import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class JobRolesResponsibilitiesValidationUtils {

    static getNonWhitespaceLength(value: string | null | undefined): number {
        if (!value) return 0;
        return value.replace(/\s/g, '').length;
    }

    static rolesResponsibilitiesValidator(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {

            if (!control.value) {
                return null;
            }

            const nonWhitespaceLength = this.getNonWhitespaceLength(control.value);

            if (nonWhitespaceLength < 30) {
                return { minlength: { requiredLength: 30, actualLength: nonWhitespaceLength } };
            }

            if (nonWhitespaceLength > 3000) {
                return { maxlength: { requiredLength: 3000, actualLength: nonWhitespaceLength } };
            }

            return null;
        };
    }


    static getRolesResponsibilitiesError(
        control: AbstractControl | null
    ): string {

        if (
            !control ||
            !control.errors ||
            !(control.touched || control.dirty)
        ) {
            return '';
        }

        if (control.errors['required']) {
            return 'Roles and Responsibilities is required.';
        }

        if (control.errors['minlength']) {
            return 'Roles and Responsibilities must contain at least 30 characters (excluding whitespace).';
        }

        if (control.errors['maxlength']) {
            return 'Roles and Responsibilities cannot exceed 3000 characters (excluding whitespace).';
        }

        return '';
    }
}